import { Provider } from '@angular/core';
import {
  AuthSplitLayoutConfig,
  provideAuthSplitLayoutConfig,
} from '@workspace/ng-aura/lib/components/layouts/auth-split-layout/auth-split-layout.interface';

export const ETXE_AUTH_LAYOUT_CONFIG: AuthSplitLayoutConfig = {
  appName: 'ETXE',
  logoUrl: '/images/logo/logo.svg',
  logoAlt: 'ETXE',
  logoLink: '/',
  heroTitle: 'ETXE',
  heroSubtitle: 'La marketplace des propriétaires et des agents certifiés',
  heroDescription:
    'Propriétaires, comparez les meilleures stratégies et commissions pour vendre votre bien en toute sérénité. Agents certifiés Carte T, accédez à des mandats qualifiés sans prospection à froid. Une collaboration transparente, équitable et performante.',
  heroSocialProof:
    "Une communauté de propriétaires exigeants et d'agents certifiés Carte T engagés pour la transparence.",
};

export function provideEtxeAuthLayoutConfig(): Provider {
  return provideAuthSplitLayoutConfig(ETXE_AUTH_LAYOUT_CONFIG);
}
